import { TOGGLE_SUDO_MODAL } from 'config/actionTypes';

export const toggleSudoModalAction: ActionTypes.App.ToggleSudoModalAction = (payload) => {
  return { type: TOGGLE_SUDO_MODAL, payload };
};
